import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resendUserInvite } from '../../actions/user';
import { storeWithExpiration } from '../../utils/common';
import { closeDialog } from '../../actions/dialog';

import UserResendInvite from './UserResendInvite';
import Dialog from '../shared/DialogForm';

class UserResendInviteContainer extends React.Component {
  static propTypes = {
    closeDialogAction: PropTypes.func.isRequired,
    cancelDialogFunction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    successFunction: PropTypes.func.isRequired,
    resendUserInviteAction: PropTypes.func.isRequired,
  };

  performResendInvite = () => {
    const { closeDialogAction, resendUserInviteAction, user, successFunction } = this.props;
    const token = storeWithExpiration.get('token');
    successFunction();
    closeDialogAction('resendInviteDialog');
    resendUserInviteAction(token, user.id, user);
  };

  render() {
    const { cancelDialogFunction, show, user } = this.props;

    const dialogContent = (
      <UserResendInvite
        cancelFunction={cancelDialogFunction}
        user={user}
        successFunction={this.performResendInvite}
      />
    );

    return (
      <Dialog
        cancelFunction={cancelDialogFunction}
        content={dialogContent}
        id="resendInviteDialog"
        show={show}
        title="Resend Invitation"
      />
    );
  }
}

export default connect(null, {
  closeDialogAction: closeDialog,
  resendUserInviteAction: resendUserInvite,
})(UserResendInviteContainer);
